import Model from "../Model";

class Representantbubbles extends Model{

    buildUrl ({ param }) {
        return ['employeeview/dataemployeebyuser', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Representantbubbles;